module.exports = __webpack_public_path__ + "static/img/osmosis.9ad6c4f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/svg/osmosis.svg
// module id = LIEW
// module chunks = 1